module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "i-editor",
    style: ({
      'z-index': _vm.zIndex
    })
  }, [_c('div', {
    ref: "toolbar",
    staticClass: "toolbar",
    style: ({
      'z-index': _vm.zIndex + 1
    })
  }, [_c('ul', [_vm._l((_vm.modules), function(module) {
    return [(module.show) ? _c('li', {
      attrs: {
        "title": _vm.locale[module.i18n]
      },
      on: {
        "click": function($event) {
          _vm.activeModule(module)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      class: module.icon
    })]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dashboard),
      expression: "dashboard"
    }],
    staticClass: "dashboard",
    style: (_vm.dashboardStyle)
  }, [(_vm.dashboard) ? _c(_vm.dashboard, {
    tag: "div",
    attrs: {
      "keep-alive": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content",
    style: (_vm.contentStyle),
    attrs: {
      "contenteditable": "true"
    },
    on: {
      "click": function($event) {
        _vm.toggleDashboard(_vm.dashboard)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3946699a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/src/editor.vue
// module id = 634
// module chunks = 0